import React from 'react';
const paths = {
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  back: <path d="M19 12H5m6-6-6 6 6 6" />,
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
    </>
  ),
  doctor: (
    <>
      <path d="M5 3v5a5 5 0 0 0 10 0V3M5 4H3m12 0h2M10 13v3a5 5 0 0 0 10 0v-3" />
      <circle cx="20" cy="10" r="2" />
    </>
  ),
  patient: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-2a8 8 0 0 1 16 0v2" />
    </>
  ),
  pharmacy: (
    <>
      <path d="M3 10h18M5 10v11h14V10M3 10l2-7h14l2 7M9 16h6m-3-3v6" />
    </>
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m16 16 5 5" />
    </>
  ),
  file: <path d="M14 2H5v20h14V7l-5-5v5h5M8 12h8M8 16h6" />,
  history: <path d="M3 11a9 9 0 1 1 2 7M3 4v7h7M12 7v5l3 2" />,
  heart: (
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" />
  ),
  pulse: <path d="M2 12h5l3-8 4 16 3-8h5" />,
  bell: <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />,
  chart: <path d="M3 3v18h18M7 16v-5m5 5V6m5 10V9" />,
  logout: <path d="M9 4H4v16h5m-1-8h13m-5-5 5 5-5 5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  check: <path d="m5 12 4 4L19 6" />,
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M7 3v4m10-4v4M3 11h18m-13 4h2m4 0h2" />
    </>
  ),
  upload: <path d="M12 16V3m-5 5 5-5 5 5M3 15v6h18v-6" />,
  close: <path d="m6 6 12 12M6 18 18 6" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />
};
const Icon = ({ name, size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {paths[name] || paths.file}
  </svg>
);
export default Icon;
